import {Component, Injector, OnInit} from '@angular/core';
import {BaseNewComponents} from '../../base-new-components';
import {FormBuilder, FormGroup} from '@angular/forms';
import {AppComponent} from '../../../app.component';
import {IPlanos as IPlan} from '../../../core/interfaces/planos.interface';
import {ProdutoService as ProductService} from '../../../core/services/produto.service';
import {CategoriaPlanoService as PlanCategoryService } from '../../../core/services/categoria_plano.service';

@Component({
  selector: 'app-plans-simulator',
  templateUrl: './plans-simulator.component.html',
  styleUrls: ['./plans-simulator.component.sass']
})
export class PlansSimulatorComponent extends BaseNewComponents implements OnInit {
  public formBuilder: FormBuilder;
  public minimumDaily = 7;
  public form: FormGroup;
  public plans: IPlan[] = [];
  public plan: IPlan;
  public doublePlans: IPlan[];
  public triplePlans: IPlan[];

  public typesOfRooms = [{value: 2, label: 'Duplo'}, {value: 3, label: 'Triplo'}];
  public dailyArray = [];

  public selectedPlan: string;
  public defaultDaily = 7;
  public selectedBedrooms = 2;

  public monthlyValue = '0';

  constructor(
      protected injector: Injector,
      private planCategoryService: PlanCategoryService,
      private productService: ProductService,
      private appComponent: AppComponent
  ) {
    super(injector);
    this.formBuilder = injector.get(FormBuilder);
  }

  async ngOnInit() {
    await this.getPlans();
    this.form = this.formInit();
    this.calculatesValues();
    this.initDailyArray();
  }
  formInit(): FormGroup {
    return this.formBuilder.group({
      plan: [{ value: this.selectedPlan, disabled: false }],
      daily: [{ value: this.defaultDaily, disabled: false}],
      bedrooms: [{ value: this.selectedBedrooms, disabled: false}],
    });
  }

  private async getPlans() {
    this.appComponent.showOverlay();
    const data: IPlan[] = await this.productService.planos() || [];
    this.doublePlans = this.planCategoryService.onlyDoubles(data, this.minimumDaily);
    this.triplePlans = this.planCategoryService.onlyTriples(data, this.minimumDaily);
    this.selectedPlan = (this.doublePlans !== null && this.doublePlans.length) ? this.doublePlans[0].codigoCategoria : '';
    this.plans = this.doublePlans;
    if(this.plans.length === 0) {
      this.monthlyValue = null;
    }
    this.appComponent.hideOverlay();
  }

  calculatesValues() {
    const selectedPlan = this.form.controls.plan.value;
    const selectedDaily = +this.form.controls.daily.value;
    const plans = this.plans.filter((plan: IPlan) => plan.codigoCategoria === selectedPlan);
    if (plans.length > 0) {
      const plan = plans[0];
      const daily = plan.qtdDiarias.filter(value => value.codigoCategoria === selectedPlan && value.quantidadeDiarias === selectedDaily);
      if (daily.length > 0) {
        this.monthlyValue = this.planCategoryService.monthlyValueDiscountString(daily[0].valor);
        this.plan = {
          codigoCategoria: plan.codigoCategoria,
          descricao: plan.descricao,
          qtdDiarias: [daily[0]],
          codigoCategoriaSales: plan.codigoCategoriaSales
        };
      }
    }
  }

  onChangePlan() {
    this.calculatesValues();
  }

  onChangeDaily() {
    this.calculatesValues();
  }

  onChangeBedrooms() {
    const selectedBedrooms = this.form.controls.bedrooms.value;
    const selectedPlan = this.form.controls.plan.value;
    this.plans = (+selectedBedrooms === 2) ? this.doublePlans : this.triplePlans;
    const newSelectedDaily = this.planCategoryService.transitionType(selectedPlan);
    this.form.controls.plan.setValue(newSelectedDaily);
    this.calculatesValues();
  }

  async onSubmit() {
    const {notAvailable = false, message = '', title = ''} = this.isMaintenance();
    if (notAvailable) {
      this.toast.error(message, title, {timeOut: 5000});
      return;
    }
    if (this.plan) {
      const selectedBedrooms = this.form.controls.bedrooms.value;
      const valuesDetailedTitle = {
        categoriaDescricao: this.plan.descricao,
        codigoCategoria: this.plan.codigoCategoria,
        codigoCategoriaSales: this.plan.codigoCategoriaSales,
        descricao: this.plan.qtdDiarias[0].descricao,
        qtdTitulos: this.plan.qtdDiarias.length,
        quantidadeDiarias: this.plan.qtdDiarias[0].quantidadeDiarias,
        valor: this.plan.qtdDiarias[0].valor
      };
      const proposalItem = {
        categoriaTitulo: this.plan.descricao,
        codigoCategoria: this.plan.codigoCategoria,
        diarias: this.plan.qtdDiarias[0].quantidadeDiarias,
        pessoas: (selectedBedrooms === 2) ? 2 : 3,
        quartos: 1,
        valor: this.plan.qtdDiarias[0].valor,
        valoresTitulosDetalhado: [valuesDetailedTitle]
      };
      const proposal = {
        cupom: '',
        cupomId: null,
        cupomAceito: false,
        fidelizacaoCliente: true,
        itensProposta: [proposalItem],
        mensagemCupom: '',
        valorAdesao: 'R$ 600,00',
        valorMensalidade: this.monthlyValue,
        valorAdesaoDesconto: 0,
        valorMensalidadeDesconto: 0,
        quartoTriplo: (selectedBedrooms === 1) ? 0 : 1,
        quartoDuplo: (selectedBedrooms === 1) ? 1 : 0
      };
      localStorage.setItem('mtl.proposta', JSON.stringify(proposal));
      await this.router.navigate(['/faca-parte']);
    }
  }

  dailyDecrement() {
    const selectedDaily = this.form.controls.daily.value;
    if (selectedDaily <= this.minimumDaily) {
      return;
    }
    this.form.controls.daily.setValue(selectedDaily - 1);
    this.calculatesValues();
  }

  dailyIncrement() {
    const selectedDaily = this.form.controls.daily.value;
    if (selectedDaily <= 27) {
      this.form.controls.daily.setValue(selectedDaily + 1);
    }
    this.calculatesValues();
  }

  private initDailyArray() {
    for (let i = this.minimumDaily; i <= 28; i++) {
      this.dailyArray.push(i);
    }
  }
}
